/** Top-level paths the logged-in shell owns: the tab shell's fallback
 * redirect must never bounce these. */
export const KNOWN_PREFIXES = [
  '/assignments',
  '/orders',
  '/timeclock',
  '/profile',
  '/welcome',
  '/select-org',
] as const

export const isKnownPath = (path: string) =>
  KNOWN_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))

/** Every root-level word the app routes (shell + auth): the short-link slug
 * parser must never claim one, whatever the base58 charset says. */
export const ROOT_ROUTE_WORDS = [
  ...KNOWN_PREFIXES,
  '/o',
  '/download',
  '/login',
  '/logout',
  '/validate',
] as const
